import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDistance } from 'date-fns';
import { ro, ru } from 'date-fns/locale';
import {
  moneyFormatterEur,
  moneyFormatterMDL,
} from '../../helpers/moneyFormatted';
import { InsuranceParameters, Offers } from '../../types';
import { iSoToDate } from '../../helpers/fromIsoToDate';
import { 
  Wrapper, 
  Column,
  ColumnSum,
  ColumnSumItem,
  InsuraceCompanyLogo,
  InsuranceInfo,
  InfoItem ,
  InfoItemAlert,
  InfoItemBold,
  AmountTitle,
  AmountSum,
  AmountTitleTotal
} from './style';

const SelectedInsuranceCard: React.FC<{
  parameters: InsuranceParameters;
  selectedOffer: Array<Offers>;
}> = ({ parameters, selectedOffer }) => {
  const {
    t,
    i18n: { language: lang },
  } = useTranslation();

  const { selectedInsurance, selectedCountry, selectedDates } = parameters;

  const startDate = iSoToDate(selectedDates?.startDate).toLocaleDateString();
  const endDate = iSoToDate(selectedDates?.endDate).toLocaleDateString();  

  const distance = formatDistance(
    iSoToDate(selectedDates.startDate),
    iSoToDate(selectedDates.endDate),
    { locale: lang.slice(0, 2) === 'ru' ? ru : ro }
  );  

  return (
    <Wrapper>
      <Column>
        <InsuraceCompanyLogo src={selectedInsurance.logo} />
        <InsuranceInfo>
          <InfoItem>
            {t('selected_country')}
            <InfoItemBold>{selectedCountry.name[lang]}</InfoItemBold>
          </InfoItem>
          <InfoItem>
            {t('when_to_go')}
            <InfoItemBold>{`${t('from')} ${startDate} ${t(
              'to'
            )} ${endDate} (${distance})`}</InfoItemBold>
          </InfoItem>
          <InfoItemAlert>{t('insurance_offer_notification')}</InfoItemAlert>
        </InsuranceInfo>
      </Column>
      <ColumnSum style={{ textAlign: 'right' }}>
        <ColumnSumItem>
          <AmountTitle>{t('insurance_summ')}</AmountTitle>
          <AmountSum>
            {moneyFormatterEur.format(selectedOffer[0]?.sum)}
          </AmountSum>
        </ColumnSumItem>
        <ColumnSumItem>
          <AmountTitleTotal>{t('insurance_price')}</AmountTitleTotal>
          <AmountSum color='blue'>
            {moneyFormatterMDL.format(selectedOffer[0]?.amount.mdl)}
          </AmountSum>
        </ColumnSumItem>
      </ColumnSum>
    </Wrapper>
  );
};

export default SelectedInsuranceCard;
